// Auto-generated transformation snapshot for InlineValueProps
// Generated: 2025-07-18T10:23:47.666Z
import type { Inject, InjectOptional } from "@tdi2/di-core/markers";
import { ApiInterface, TestStateInterface } from "./shared-types";
import { useService, useOptionalService } from "@tdi2/di-core/context";

export function InlineValueProps(props: {
  services: {
    api: Inject<ApiInterface>;
  };
}) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{api.getData()}Mixed dependencies component</div>;
}

export function InlineValueFoo(props: {
  services: {
    api: Inject<ApiInterface>;
  };
}) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{api.getData()}Mixed dependencies component</div>;
}

export function InlineDestructuredNested(props: {
      services: {
        api: Inject<ApiInterface>;
      };
    }) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{api.getData()}Mixed dependencies component</div>;
}

export function InlineDestructured(props: { api: Inject<ApiInterface> }) {
    const api = props.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{api.getData()}Mixed dependencies component</div>;
}

export function InlineDestProps(props: {
  services: {
    api: Inject<ApiInterface>;
  };
}) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{api.getData()}Mixed dependencies component</div>;
}

export function InlineDestructured2ndApi(props: {
      services: {
        api: Inject<ApiInterface>;

        state: Inject<TestStateInterface>;
      };
    }) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
    const state = props.services?.state; if (!state) {throw new Error("Could not find implementation for 'TestStateInterface'");}
  return <div>{state.value}Mixed dependencies component</div>;
}

export interface Todo {
  id: string;
  title: string;
  completed: boolean;
  createdAt: Date;
  updatedAt: Date;
}

interface TodoCardProps {
  todo: Todo;
  services: {
    api: Inject<ApiInterface>;
  };
}

export function TodoCard(props: TodoCardProps) {
    const api = props.services?.api;
    const { todo } = props; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{todo.completed ? "completed" : "not completed"}</div>;
}

export function TodoCard2(props: TodoCardProps) {
    const api = props.services?.api;
    const { todo } = props; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{todo.completed ? "completed" : "not completed"}</div>;
}

/**
 *    FIXME todo from function args too aggressivly removed with DI extract step
 *    Note we already had a similar issue with function body destructuring
 */
export function TodoCard3(props: TodoCardProps) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{todo.completed ? "completed" : "not completed"}</div>;
}

/**
 *    FIXME todo from function args too aggressivly removed with DI extract step
 *    Note we already had a similar issue with function body destructuring
 */
export function TodoCard4(props: TodoCardProps) {
    const api = props.services?.api; if (!api) {throw new Error("Could not find implementation for 'ApiInterface'");}
  return <div>{todo.completed ? "completed" : "not completed"}</div>;
}
